export class UploadFieldConfigResponse {

    configKey: string;
    multipleUpload: boolean;
    label: string;
    required: boolean;
    readonly: boolean;
    helptextIcon: string;
    helptextAbove: string;
    helptextBelow: string;
    fileLimit: number;
    sizeLimit: number;

    /**  z. B. *.png */
    accept: string;

    showCategoryIfUnique: boolean;
    allowComment: boolean;
    documentMetadataCategoryIds: Set<number>;
    css: string;
    uploadForLargeFiles: boolean;
    sourceTypes: Set<string>;
    localMediaCategories: Set<string>;
}
